<template>
	<aside class="filter" id="filter" :class="showfilters ? 'open' : null">
		<div class="filter-header">
			<h2>Filter</h2>
			<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-mobile" v-on:click="clearFilters()">clear all filters</a>
			<i class="icon icon-close filter-close hide-desktop" v-on:click="updateShowFilters"></i>
		</div>
		<div class="filters" id="filters">
			<div class="filter-section">

				<a href="javascript:void(0)" class="js-filter-clear filter-clear hide-desktop" v-on:click="clearFilters()">clear all filters</a>
				<h3>Show Only</h3>
				<ul class="filters-categories input-group">

					<li class="category">
						<div class="form-group form checkox-input">
							<input name="show-only" id="staff" type="radio" value="showOnlyStaff" v-model="showOnly"/>
							<label for="staff">Staff</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkox-input">
							<input name="show-only" id="my-lmc" type="radio" value="showMyLmcTeam" v-model="showOnly"/>
							<label for="my-lmc">My LMC Team</label>
						</div>
					</li>

				</ul>
			</div>

			<div class="filter-section">
				<div class="form-group select-input">
					<label for="departments" class="label-large">Filter By Department</label>
					<select id="departments" class="form-control" v-model="filters.departmentID">
						<option value="" disabled>
							Select an Option
						</option>
						<option v-for="item in department" :value="item.DepartmentID">
							{{item.DisplayName}}
						</option>

					</select>
				</div>
			</div>
			<div class="filter-section">

				<div class="form-group select-input">
					<label for="sortBy" class="label-large">Sort By</label>
					<select id="sortBy" class="form-control" v-model="filters.sortBy">
						<option v-for="order in sortBy" :value="order.param">
							{{order.displayName}}
						</option>
					</select>
				</div>


			</div>
		</div>
		<div class="filter-actions" :class="filterActionsStuck ? 'static' : ''">
			<button class="btn" v-on:click="applyFilters()">Apply Filters</button>
			<a href="javascript:void(0)" class="js-filter-clear hide-mobile" v-on:click="clearFilters()">Clear Filters</a>
		</div>
	</aside>

</template>


<script>
	export default {
		data: function () {
			return {
				filterActionsStuck: false,
				styleObject: {},
				department: [],
				showOnly: 'showMyLmcTeam',
                sortBy: [{ param: 'LastName', displayName: 'Last Name' }, { param: 'FirstName', displayName: 'First Name' }],
				filters: {
                    sortBy: 'LastName',
					departmentID: '',
					showOnlyStaff: false,
					showMyLmcTeam: true
				},
			}
		},
		props: {
			showfilters: {
				type: Boolean,
				default: () => false
			},

		},
		watch: {
			showfilters: function (newVal) {
				this.showfilters = newVal;

				let body = document.getElementsByTagName("BODY")[0];

				if (newVal === true) {
					body.classList.add('collapse-shown');
					body.classList.remove('collapse-hide');
				}
				else {
					body.classList.add('collapse-hide');
					body.classList.remove('collapse-shown');
				}
			}

		},

		mounted() {
			this.department = window.departmentfilters;

			$(window).on('scroll', e => { this.stickFilterActions() });
		},


		methods: {

			stickFilterActions() {
				let $stickyElem = $('.filter-actions');
				let $filters = $('#filters');
				let filterOffset = Math.round($filters.offset().top);
				let filterHeight = $filters.outerHeight();
				let stickyHeight = $stickyElem.outerHeight();
				let viewHeight = $(window).height();
				let totalHeight = filterHeight + (stickyHeight*2);

				$('.filter + .content-wrapper-main').css('minHeight', totalHeight);

				let offset = filterOffset + filterHeight + stickyHeight - $(window).scrollTop();

				if ((offset <= viewHeight) && !this.filterActionsStuck) {
					this.filterActionsStuck = true;
				}
				if ((offset > viewHeight) && this.filterActionsStuck) {
					this.filterActionsStuck = false;
				}
			},
			applyFilters() {

				if (this.showOnly === 'showOnlyStaff') {
					this.filters.showOnlyStaff = true;
					this.filters.showMyLmcTeam = false;
				}
				else if (this.showOnly === 'showMyLmcTeam') {
					this.filters.showOnlyStaff = false;
					this.filters.showMyLmcTeam = true;
				}

				// convert for api call
				let formatFilters = Object.assign({}, this.filters);

				//// encode strings
				//formatFilters.categories = formatFilters.categories;
			
				this.$emit('setdirectoryfilter', formatFilters);
				this.updateShowFilters();
			},
			clearFilters() {
                this.showOnlyStaff = false;
                this.showMyLmcTeam = true;
				this.filters.departmentID = '';
				this.filters.sortBy = 'LastName';
                this.showOnly = 'showMyLmcTeam';

				this.$emit('clearfilters');
				this.applyFilters();
			},
			updateShowFilters() {
                this.$emit('updateshowfilters', false);
			}
		}
	}

</script>